import { addToGlobalDataLayer, resetGlobalDataLayer } from '@ncl/modules/shared/globals/datalayer';

import {
  DEFAULT_PERCENTAGE_LICITACAO,
  DEFAULT_PERCENTAGE_PERFORMANCE,
  MAX_PERCENTAGE_LICITACAO,
  MAX_PERCENTAGE_PERFORMANCE,
} from '../../core/constants/values';
import { updateLead } from '../services/LeadServices';

/* eslint-disable no-param-reassign */
export function changeDefaultPercentageOnModalityChange(change, store) {
  const { newValue: modalityId } = change;

  switch (modalityId) {
    case 99:
      store.WarrantyPercentage = DEFAULT_PERCENTAGE_LICITACAO;
      store.MaxWarrantyPercentage = MAX_PERCENTAGE_LICITACAO;
      break;
    case 122:
      store.WarrantyPercentage = '';
      break;
    default:
      store.WarrantyPercentage = DEFAULT_PERCENTAGE_PERFORMANCE;
      store.MaxWarrantyPercentage = MAX_PERCENTAGE_PERFORMANCE;
      break;
  }
}

export function resetStoreOnModalityChange(change, store) {
  const hasChanged = hasModalityChanged(change, store);
  if (hasChanged && change.newValue) {
    store.reset();
    resetGlobalDataLayer();
  }
}

export function updateLeadOnModalityChanged(change, store) {
  const { newValue } = change;
  const { Lead } = store;
  const leadSaved = Object.keys(Lead).length !== 0;

  const shouldUpdate = leadSaved && Lead.modalidadeId !== newValue && newValue;

  if (!shouldUpdate) {
    return;
  }

  updateLead(Lead.id, { modalidadeId: change.newValue });
  store.Lead.modalidadeId = change.newValue;
}

export function updateGlobalsOnModalityChange(change, store) {
  if (hasModalityChanged(change, store)) {
    const { newValue } = change;
    addToGlobalDataLayer('Modalidade', newValue);
  }
}

export function updateGlobalsOnTotalAmountChange({ newValue }) {
  addToGlobalDataLayer('IS', newValue);
}

export function updateGlobalsOnDurationInDaysChange(change) {
  addToGlobalDataLayer('Vigencia', change.newValue);
}

export function updateGlobalsOnQuoteChanged(change) {
  const { newValue: quote } = change;

  addToGlobalDataLayer('Premio', quote.premioLiquido);
}

export function updateLeadOnContractValueChanged(change) {
  addToGlobalDataLayer('ValorDoContrato', change.newValue);
}

function hasModalityChanged(change, store) {
  const { newValue } = change;
  const oldValue = store.ModalityId;

  return newValue !== oldValue;
}
